import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import FundMappingsService from 'donor-elf-web/services/fund-mappings-service';

export default class FundMappingHostFundNameHelper extends Helper {
  @service declare fundMappingsService: FundMappingsService;

  compute(
    _positionalArgs: string[],
    { database, hostId }: { hostId: string; database?: string },
  ) {
    return (
      this.fundMappingsService.getHostFund({ hostId, database })?.name || hostId
    );
  }
}
